import React from "react";
import DataSection from "../components/sections/Data.jsx";
import SliderSection from "../components/sections/Slider.jsx";
import { data } from "../constants/hissenet/data.js";
import { projeler } from "../constants/hissenet/projeler.js";
import { useLanguage } from "../contexts/LanguageContext";

export default function Hissenet() {
  const { language } = useLanguage();

  return (
    <div className="flex flex-col">
      <img
        src={
          language === "TR"
            ? "https://srv-cdn.onedio.com/store/8f8f7db2420bfc774316741bcc5ebca9cdea959ec59233494ff49e357acccba0.jpg"
            : "https://srv-cdn.onedio.com/store/005c12d634d26ac51418495b97eaa3cc26728c502a94cf8e5654f4751e1ffdbf.png"
        }
        className="w-full max-w-[1440px] mx-auto"
        alt=""
      />
      <DataSection data={data} title="Datalar" name="datalar" />
      <SliderSection
        className={"bg-[#FEF9F3]"}
        data={projeler}
        circle={false}
        name="hissenet-projeler"
      />
    </div>
  );
}
